"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const _1 = require("./");
class DangerZone extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            modalOpen: false,
        };
        this.toggleModal = () => this.setState({ modalOpen: !this.state.modalOpen });
        this.confirmRemove = () => {
            this.toggleModal();
            this.props.onRemoveConfirmation();
        };
    }
    render() {
        const { modalTitle, modalMessage, text } = this.props;
        const { modalOpen } = this.state;
        return (React.createElement("div", { className: "danger-zone" },
            React.createElement("h2", { className: "danger-zone-title" }, "Danger Zone"),
            React.createElement("p", null, text),
            React.createElement(_1.Button, { className: "btn-uppercase", color: "danger", size: "lg", onClick: this.toggleModal }, "Delete"),
            React.createElement(_1.Modal, { isOpen: modalOpen, toggle: this.toggleModal },
                React.createElement(_1.ModalHeader, null, modalTitle),
                React.createElement(_1.ModalBody, null, modalMessage),
                React.createElement(_1.ModalFooter, null,
                    React.createElement(_1.Button, { color: "danger", size: "lg", onClick: this.confirmRemove }, "Delete"),
                    React.createElement(_1.Button, { color: "secondary", size: "lg", onClick: this.toggleModal }, "Cancel")))));
    }
}
exports.DangerZone = DangerZone;



//////////////////
// WEBPACK FOOTER
// ./src/components/DangerZone.tsx
// module id = 242
// module chunks = 0